import {
  Home,
  User,
  DollarSign,
  Star,
  Package,
  Clock,
  Receipt,
  LayoutDashboard,
  Users,
  Briefcase,
  BarChart2,
  Bell,
  ClipboardList,
  LifeBuoy,
  Inbox,
} from "lucide-react";

export const NAV_CONFIG = {
  baba: [
    { key: "inicio",       label: "Início",       icon: Home },
    { key: "perfil",       label: "Perfil",        icon: User },
    { key: "faturamento",  label: "Faturamento",   icon: DollarSign },
    { key: "assinaturas",  label: "Assinaturas",   icon: Star },
  ],
  familia: [
    { key: "inicio",        label: "Início",        icon: Home },
    { key: "contratacoes",  label: "Contratações",  icon: ClipboardList },
    { key: "perfil",        label: "Perfil",         icon: User },
    { key: "pacotes",       label: "Pacotes",        icon: Package },
    { key: "assinaturas",   label: "Planos",         icon: Star },
    { key: "historico",     label: "Histórico",      icon: Clock },
    { key: "suporte",       label: "Suporte",        icon: LifeBuoy },
    { key: "extrato",       label: "Extrato",        icon: Receipt },
  ],
  admin: [
    { key: "Dashboard",    label: "Dashboard",   icon: LayoutDashboard },
    { key: "Perfil",       label: "Meu Perfil",  icon: User },
    { key: "Cadastros",    label: "Cadastros",   icon: Users },
    { key: "Solicitacoes", label: "Solicitações", icon: Inbox },
    { key: "Produtos",     label: "Produtos",    icon: Package },
    { key: "Trabalhos",    label: "Trabalhos",   icon: Briefcase },
    { key: "Financeiro",   label: "Financeiro",  icon: BarChart2 },
    { key: "Atualizações", label: "Updates",     icon: Bell },
  ],
};